var image_viewer_rtlignore_default = {
  "fontElementMap": "isyAp",
  "imageContainer": "Bw3ux",
  "expandButton": "lMAyp",
  "expandIcon": "fsKpW",
  "pointer": "bmehm",
  "imageWrapper": "lts7f",
  "imageRatio": "Qg914",
  "image": "TP9Qv",
  "imageOverlay": "ERB6p",
  "imagePreload": "yak46",
  "imageHighres": "_1NrwO",
  "onlyHighRes": "ZhnGk",
  "image_loading": "piWch"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
